import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 48 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 1, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "" }) => (
  <p
    className={`font-sans text-[11px] font-medium uppercase tracking-[0.25em] text-neutral-500 sm:text-xs sm:tracking-[0.35em] ${className}`}
  >
    {children}
  </p>
);

export const scrollTo = (id) => {
  const el = typeof id === "string" ? document.querySelector(id) : id;
  if (!el) return;
  const top = el.getBoundingClientRect().top + window.scrollY - 72;
  window.scrollTo({ top });
};
